import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBuzzSubscriptionPlanOptions } from './BuzzSlice';

const EMPTY = {
  ecosystems: [],
  productCategories: [],
  licenseQuotaTypes: [],
  licenseTypes: {},
  productClasses: {},
  akademy: { masterCoordinatorProducts: [], languages: [] },
};

/**
 * Ecosystems, product categories, licence quota types, per-ecosystem licence types and the
 * classes each class-bound product covers,
 * served by buzzOne (`GET buzz/subscriptions/plans/options`). Fetched once per session;
 * empty lists until it arrives, so callers should list it in their effect dependencies.
 */
export default function usePlanOptions() {
  const dispatch = useDispatch();
  const planOptions = useSelector(({ buzz }) => buzz.planOptions);

  useEffect(() => {
    if (!planOptions) dispatch(getBuzzSubscriptionPlanOptions());
  }, []);

  return planOptions || EMPTY;
}
